import { useContext } from "react";
import { LocaleContext } from "./LocaleProvider";

/**
 * Hook providing the translator function and the current locale.
 * Must be used inside <LocaleProvider> — throws otherwise so misuse
 * is caught immediately in dev.
 */
export function useTranslation() {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    throw new Error("useTranslation must be used inside <LocaleProvider>");
  }
  return ctx;
}
